import { render, staticRenderFns } from "./couponDoctor.vue?vue&type=template&id=4cb9152b&scoped=true&"
import script from "./couponDoctor.vue?vue&type=script&lang=js&"
export * from "./couponDoctor.vue?vue&type=script&lang=js&"
import style0 from "./couponDoctor.vue?vue&type=style&index=0&id=4cb9152b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9152b",
  null
  
)

export default component.exports